import * as types from "../actions/types";
/*******************
@purpose : Intital ui reducer data
@Author : INIC
******************/
const initialState = {
  isLoad: false,
  messages: [],
  modals: {
    login: false,
    register: false,
    welcomeMessage: false,
    cookieModal: true,
  },
  loaders: {
    content_loader: false,
    page_loader: false,
    button_loader: false,
  },
  showDocumentHideProfile: true,
  showEditProfileHideShowProfile: true,
  showPaymentHideProfile: true,
  showSuccessAlert: { show: false, text: "", error: false },
  showOtpBlock: false,
  activeTab: "personalInfo",
};

/*******************
@purpose : UI Reducer
@Parameter : {ui_ini_data, action}
@Author : INIC
******************/
export default function ui(ui_ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_UI_KEY:
      return Object.assign({}, ui_ini_data, {
        [action.key]: action.data,
      });
    // Show Alert Notification .
    case types.SHOW_ALERT:
      let tempMessages = Object.assign([], ui_ini_data.messages);
      tempMessages.push({
        text: action.text,
        level: action.level,
        timeout: action.timeout,
      });
      return Object.assign({}, ui_ini_data, {
        messages: tempMessages,
      });
    // Remove Alert Notification
    case types.REMOVE_ALERT:
      return Object.assign({}, ui_ini_data, {
        messages: [],
      });
    // Set Page Loader
    case types.TOGGLE_LOADER:
      let loaders = Object.assign({}, ui_ini_data.loaders);
      loaders[action.key] = action.value;
      return Object.assign({}, ui_ini_data, {
        loaders,
      });
    case types.BUTTON_LOADER:
      let buttonLoaders = Object.assign({}, ui_ini_data.loaders);
      buttonLoaders[action.key] = action.value;
      return Object.assign({}, ui_ini_data, {
        loaders,
      });
    // Open/Close Modal
    case types.TOGGLE_MODAL:
      let modals = Object.assign({}, ui_ini_data.modals);
      modals[action.key] = action.value;
      return Object.assign({}, ui_ini_data, {
        modals,
      });
    case types.SHOW_DOCUMENT_HIDE_PROFILE:
      return Object.assign({}, ui_ini_data, {
        showDocumentHideProfile: action.data,
      });

    case types.SET_SHOW_OTP_BLOCK:
      return Object.assign({}, ui_ini_data, {
        showOtpBlock: action.data,
      });

    case types.SHOW_EDIT_PROFILE_HIDE_SHOW_PROFILE:
      return Object.assign({}, ui_ini_data, {
        showEditProfileHideShowProfile: action.data,
      });
    case types.SHOW_PAYMENT_HIDE_SHOW_PROFILE:
      return Object.assign({}, ui_ini_data, {
        showPaymentHideProfile: action.data,
      });
    case types.SHOW_SUCESSS_POPUP:
      return Object.assign({}, ui_ini_data, {
        showSuccessAlert: {
          text: action.text,
          show: action.show,
          error: action.isError,
        },
      });
    case types.SET_ACTIVE_TAB:
      return Object.assign({}, ui_ini_data, {
        activeTab: action.data,
      });
    default:
      return ui_ini_data;
  }
}
